<div class="report-container">
  <!-- Page Header -->
  <p class="TXT_TITLE w-30">: : {{ constants.itemDetailsReportPnA }} : :</p>

  <!-- Filter Form -->
  <div class="report-form">
    <!-- Row 1: Location, Purchasing Office, Date From, Date To -->
    <div class="form-row">
      <div class="form-field">
        <label class="form-label">{{ constants.location }}:</label>
        <nz-select
          [(ngModel)]="filters.location"
          name="location"
          nzPlaceHolder="Select Location"
        >
          <nz-option nzValue="ALL" nzLabel="{{ constants.lovAll }}"></nz-option>
          <nz-option
            *ngFor="let loc of locations"
            [nzValue]="loc.code"
            [nzLabel]="loc.description"
          ></nz-option>
        </nz-select>
      </div>

      <div class="form-field">
        <label class="form-label">{{ constants.purchasingOffice }}:</label>
        <nz-select
          [(ngModel)]="filters.purchasingOffice"
          name="purchasingOffice"
          (ngModelChange)="onPurchasingOfficeChange()"
          nzPlaceHolder="Select Purchasing Office"
        >
          <nz-option nzValue="ALL" nzLabel="{{ constants.lovAll }}"></nz-option>
          <nz-option
            *ngFor="let po of purchasingOffices"
            [nzValue]="po.purchasingName"
            [nzLabel]="po.purchasingName"
          ></nz-option>
        </nz-select>
      </div>

      <div class="form-field">
        <label class="form-label"
          ><span class="required">*</span>{{ constants.createDateFrom }}:</label
        >
        <nz-date-picker
          [(ngModel)]="filters.dateFrom"
          name="dateFrom"
          nzFormat="yyyy-MM-dd"
          nzPlaceHolder="Select start date"
          nzSize="default"
        >
        </nz-date-picker>
      </div>

      <div class="form-field">
        <label class="form-label"
          ><span class="required">*</span>{{ constants.to }}:</label
        >
        <nz-date-picker
          [(ngModel)]="filters.dateTo"
          name="dateTo"
          nzFormat="yyyy-MM-dd"
          nzPlaceHolder="Select end date"
          nzSize="default"
        >
        </nz-date-picker>
      </div>
    </div>

    <!-- Row 2: Status Checkboxes -->
    <div class="form-row full-width">
      <div class="form-field status-field">
        <div class="status-container">
          <label class="form-label"
            ><span class="required">*</span>{{ constants.status }}:</label
          >
          <div class="status-checkboxes">
            <label
              nz-checkbox
              *ngFor="let status of statusOptions"
              [ngModel]="selectedStatuses.includes(status.key)"
              (ngModelChange)="onStatusChange(status.key, $event)"
              [ngModelOptions]="{ standalone: true }"
            >
              {{ status.label }}
            </label>
          </div>
        </div>
      </div>
    </div>

    <!-- Row 3: Buyer, Request By, Company Code (all in one row) -->
    <div class="form-row">
      <div class="form-field">
        <label class="form-label">{{ constants.buyer }}:</label>
        <nz-select
          nzShowSearch
          [(ngModel)]="filters.buyer"
          name="buyer"
          (ngModelChange)="onBuyerDropdownChange()"
          nzPlaceHolder="Select Buyer"
        >
          <nz-option nzValue="ALL" nzLabel="{{ constants.lovAll }}"></nz-option>
          <nz-option
            *ngFor="let buyer of filteredBuyers"
            [nzValue]="buyer.userId"
            [nzLabel]="buyer.fullName"
          ></nz-option>
        </nz-select>
      </div>
      <div class="form-field">
        <label class="form-label">{{ constants.requestBy }}:</label>
        <nz-select
          nzShowSearch
          [(ngModel)]="filters.owner"
          name="owner"
          (ngModelChange)="onOwnerDropdownChange()"
          nzPlaceHolder="Select Requestor"
        >
          <nz-option nzValue="ALL" nzLabel="{{ constants.lovAll }}"></nz-option>
          <nz-option
            *ngFor="let owner of filteredOwners; trackBy: trackByOwner"
            [nzValue]="owner.pnaCreateBy"
            [nzLabel]="owner.pnaRequestor"
          ></nz-option>
        </nz-select>
      </div>
      <div class="form-field">
        <label class="form-label">{{ constants.companyCode }}:</label>
        <nz-select
          [(ngModel)]="filters.ccn"
          name="ccn"
          nzPlaceHolder="Select Company Code"
        >
          <nz-option nzValue="ALL" nzLabel="{{ constants.lovAll }}"></nz-option>
          <nz-option
            *ngFor="let ccn of ccns"
            [nzValue]="ccn.ccnCode"
            [nzLabel]="ccn.ccnCode"
          ></nz-option>
        </nz-select>
      </div>
    </div>

    <!-- Action Buttons -->
    <div class="form-actions">
      <button nz-button nzType="primary" (click)="generateHtmlReport()">
        {{ constants.htmlReportButton }}
      </button>
      <button nz-button nzType="primary" (click)="generateExcelReport()">
        {{ constants.excelReportButton }}
      </button>
    </div>
  </div>

  <!-- Results Table -->
  <div *ngIf="showGrid" class="results-section">
    <p class="TXT_TITLE">Report P&A</p>

    <nz-table
      class="StyleTable"
      #reportsData
      nzBordered
      [nzData]="reports"
      [nzPageSize]="pageSize"
      [nzPageIndex]="pageIndex"
      (nzPageIndexChange)="onPageIndexChange($event)"
      (nzPageSizeChange)="onPageSizeChange($event)"
      [nzTotal]="total"
      [nzPageSizeOptions]="[10, 20, 50, 100]"
      [nzFrontPagination]="false"
      [nzShowSizeChanger]="true"
      [nzNoResult]="customNoDataMessage"
    >
      <thead>
        <tr>
          <th>#</th>
          <th>{{ constants.PnaNo }}</th>
          <th>{{ constants.submittedDate }}</th>
          <th>{{ constants.pnaTitle }}</th>
          <th>{{ constants.requestorName }}</th>
          <th>{{ constants.buyer }}</th>
          <th>{{ constants.location }}</th>
          <th>{{ constants.purchasingOffice }}</th>
          <th>{{ constants.companyCode }}</th>
          <th>{{ constants.itemCount }}</th>
          <th>{{ constants.updatedDate }}</th>
          <th>{{ constants.status }}</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let report of reportsData.data; let i = index">
          <td>{{ (pageIndex - 1) * pageSize + i + 1 }}</td>
          <td>{{ report.pnaNo }}-{{ report.pnaYear }}</td>
          <td>
            {{
              report.submitDate ? (report.submitDate | date : "dd-MMM-yy") : ""
            }}
          </td>
          <td>{{ report.pnaTitle }}</td>
          <td class="text-left">{{ report.pnaRequestor }}</td>
          <td class="text-left">{{ report.pnaBuyer }}</td>
          <td>{{ report.pnaLocation }}</td>
          <td>{{ report.pnaPurchasing }}</td>
          <td>{{ report.pnaCcn }}</td>
          <td>{{ report.itemCount }}</td>
          <td>
            {{
              report.updatedDate
                ? (report.updatedDate | date : "dd-MMM-yy")
                : ""
            }}
          </td>
          <td>{{ report.pnaStatus }}</td>
        </tr>
      </tbody>
    </nz-table>
  </div>
</div>
